import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const EggSpotlight = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  // gentler than the old floating egg: a tray reads as resting, so a strong
  // tilt makes it look like the eggs are about to slide out
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [5, -5]), { stiffness: 120, damping: 16 });
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-6, 6]), { stiffness: 120, damping: 16 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <div
      data-testid="hero-egg-visual"
      className="relative mx-auto grid h-64 w-64 place-items-center sm:h-80 sm:w-80"
      style={{ perspective: 900 }}
      onPointerMove={onMove}
      onPointerLeave={onLeave}
    >
      <div className="absolute inset-0 rounded-full bg-[radial-gradient(circle_at_50%_45%,rgba(197,160,89,0.45),rgba(197,160,89,0.14)_50%,transparent_72%)]" />
      <motion.div
        initial={{ opacity: 0, scale: 0.82, y: 24 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 1.1, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
      >
        <motion.div
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="relative z-10 overflow-hidden rounded-[12%] ring-1 ring-[#C5A059]/40 shadow-[0_26px_44px_rgba(107,29,47,0.26)]"
        >
          <img
            data-testid="hero-egg-image"
            src={`${process.env.PUBLIC_URL}/hero-eggs-896.webp`}
            srcSet={`${process.env.PUBLIC_URL}/hero-eggs-512.webp 512w, ${process.env.PUBLIC_URL}/hero-eggs-896.webp 896w`}
            sizes="(min-width: 640px) 256px, 208px"
            width={896}
            height={896}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            alt="Farm-fresh white eggs resting point-down in a moulded pulp tray at KSR Poultry Farms"
            className="block h-52 w-52 object-cover sm:h-64 sm:w-64"
          />
        </motion.div>
      </motion.div>
      <div className="absolute bottom-4 h-4 w-36 rounded-full bg-[#6B1D2F]/15 blur-md" />
    </div>
  );
};

export default EggSpotlight;
